import { createAction, props } from '@ngrx/store';
import { SingleGraphError } from 'src/app/common-components/errors/models/error-message';
import { ExtensionGroupDetailSaveEvent } from '../models/extension-group-detail-form-submit-event';
import { GetExtensionGroupDetail_extensionGroup } from '../queries/generated/GetExtensionGroupDetail';
import { SaveExtensionGroup } from '../queries/generated/SaveExtensionGroup';

export const extensionGroupDetailLoad = createAction('[ExtensionGroup Detail] Load');

export const extensionGroupDetailCancel = createAction('[ExtensionGroup Detail] Cancel');

export const extensionGroupDetailAccessDenied = createAction('[ExtensionGroup Detail] Access Denied');

export const loadExtensionGroupDetailSuccess = createAction(
   '[API] Load ExtensionGroup Success',
   props<{ data: GetExtensionGroupDetail_extensionGroup }>()
);

export const loadExtensionGroupDetailFailure = createAction(
   '[API] Load ExtensionGroup Failure',
   props<SingleGraphError>()
);

export const saveExtensionGroupDetail = createAction(
   '[ExtensionGroup Detail] Save',
   props<ExtensionGroupDetailSaveEvent>()
);

export const saveExtensionGroupDetailSuccess = createAction(
   '[ExtensionGroup Detail] Save Success',
   props<{ data: SaveExtensionGroup }>()
);

export const saveExtensionGroupDetailFailure = createAction(
   '[ExtensionGroup Detail] Save Failed',
   props<SingleGraphError>()
);

export const deleteExtensionGroup = createAction(
   '[ExtensionGroup Detail] Delete ExtensionGroup',
   props<{ extensionGroupId: number }>()
);

export const deleteExtensionGroupSuccess = createAction(
   '[ExtensionGroup Detail] Delete ExtensionGroup Success',
   props<{ extensionGroupId: number }>()
);

export const deleteExtensionGroupFailure = createAction(
   '[ExtensionGroup Detail] Delete ExtensionGroup Failure',
   props<SingleGraphError>()
);
